import { render, staticRenderFns } from "./ReadMoreText.vue?vue&type=template&id=0b5dede3"
import script from "./ReadMoreText.vue?vue&type=script&lang=js"
export * from "./ReadMoreText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports